import { Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Paper, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";

export default function TalentExceptionForm({
    talentFormData: formData,
    setTalentFormData: setFormData
}) {

    const handleChange = (field, value) => setFormData({ ...formData, [field]: value });

    return (
        <Stack spacing={2}>
            <Typography variant="h4">Déclaration d’intérêt – Talents d’exception</Typography>
            <Divider sx={{ my: 2 }} />

            {/* SECTION 1 — ACCOMPLISSEMENT RECONNU */}
            <Typography variant="h5" sx={{ mt: 3 }}>
                Accomplissement reconnu
            </Typography>

            <FormControl required sx={{ my: 1 }}>
                <FormLabel>Possédez-vous un accomplissement inscrit à la Liste des accomplissements reconnus au volet 4 - Talents d'exception ?</FormLabel>

                <RadioGroup row onChange={e => handleChange('hasRecognizedAchievement', e.target.value)}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {formData.hasRecognizedAchievement === 'Oui' && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2, backgroundColor: '#fafafa' }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Veuillez préciser :
                    </Typography>

                    {[
                        { key: 'recognizedCanadaExcellenceChair', label: 'Chaire d’excellence du Canada' },
                        { key: 'recognizedCanadaResearchChair', label: 'Chaire de recherche du Canada' },
                        { key: 'recognizedUNESCOChair', label: 'Chaire de recherche de l’UNESCO' },
                        { key: 'recognizedInstitutionalChair', label: 'Chaire de recherche institutionnelle' },
                        { key: 'recognizedMinisterialChair', label: 'Chaire de recherche ministérielle' }
                    ].map(item => (
                        <FormControlLabel key={item.key} control={<Checkbox checked={formData[item.key]} onChange={e => handleChange(item.key, e.target.checked)} />} label={item.label} />
                    ))}
                </Paper>
            )}

            <Divider sx={{ my: 3 }} />

            {/* SECTION 2 — AVIS POSITIF PARTENAIRE */}
            <Typography variant="h5" sx={{ mt: 3 }}>
                Avis positif d’un partenaire du Ministère
            </Typography>

            <FormControl required sx={{ my: 1 }}>
                <FormLabel>Possédez-vous un avis positif d’un partenaire du Ministère relatif à votre talent d'exception ?</FormLabel>

                <RadioGroup row onChange={e => handleChange('hasPositivePartnerOpinion', e.target.value)}>
                    <FormControlLabel value="Oui" control={<Radio required />} label="Oui" />
                    <FormControlLabel value="Non" control={<Radio required />} label="Non" />
                </RadioGroup>
            </FormControl>

            {formData.hasPositivePartnerOpinion === 'Oui' && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2, backgroundColor: '#fafafa' }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Veuillez préciser :
                    </Typography>

                    {[
                        { key: 'partnerCALQ', label: 'Conseil des arts et des lettres du Québec (CALQ)' },
                        { key: 'partnerFRQ', label: 'Fonds de recherche du Québec (FRQ)' },
                        { key: 'partnerINS', label: 'Institut national du Sport du Québec (INS)' },
                        { key: 'partnerMEIE', label: 'Ministère de l’Économie, de l’Innovation et de l’Énergie (MEIE)' }
                    ].map(item => (
                        <FormControlLabel key={item.key} control={<Checkbox checked={formData[item.key]} onChange={e => handleChange(item.key, e.target.checked)} />} label={item.label} />
                    ))}
                </Paper>
            )}

            <Divider sx={{ my: 3 }} />

            {/* SECTION 3 — NUMÉRO D’AVIS */}
            <Typography variant="h5"> Numéro d’avis</Typography>

            <TextField required fullWidth sx={{ my: 2 }} label="Numéro d’avis" value={formData.talentOpinionNumber} onChange={e => handleChange('talentOpinionNumber', e.target.value)} />

            <Divider sx={{ my: 3 }} />
    </Stack>
    );
}